import React from 'react';
import './style.scss';
import { useCorporateAccountOpenProfileDetails, useAdvanceQuestionValueModule } from './hooks';
import { useParams } from 'react-router-dom';

export const CorporateAccountOpenProfileDetails = () => {
  const { accountOpenProfileDetailsPageType, SwitchPage } = useCorporateAccountOpenProfileDetails();
  const { uniqueId } = useParams();

  useAdvanceQuestionValueModule(uniqueId);

  return (
    <>
      <div className="accountOpen">{SwitchPage(accountOpenProfileDetailsPageType)}</div>
    </>
  );
};
